import { Component, ViewChild, ElementRef } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from '@angular/forms';
import { ApiService } from './services/api.service';
import { Captcha, TpDocumento, AlertMessage } from 'src/app/models';
import { ActivatedRoute } from '@angular/router';
import { formatDate } from 'src/app/_helper/functions';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  is_dev = !environment.production;
  @ViewChild('recaptcha', { static: true })
  recaptchaElement: ElementRef;

  title = 'verifica-autenticidade';
  dt = new Date();

  submit_hover = false;
  is_submit = false;
  err_msg: AlertMessage;

  formValidar: FormGroup;
  captcha: Captcha;
  captchaStr;

  document_type_list: TpDocumento[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private api: ApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    this.api.getTpDocumento().subscribe(
      res => {
        this.document_type_list = res[0];
        const tp_documento = this.document_type_list.find(
          el => el.tp_documento == this.route.snapshot.queryParams['tp_doc'],
        );
        this.formValidar.setValue({
          id_tp_documento: tp_documento?.id_tp_documento || '',
          ano_documento: this.route.snapshot.queryParams['ano'] || '',
          cod_autenticidade: this.route.snapshot.queryParams['cod'] || '',
          num_documento: this.route.snapshot.queryParams['num'] || '',
        });
        this.spinner.hide();
      },
      err => {
        console.error(err);
        this.toastr.error('Erro ao carregar os dados');
        this.spinner.hide();
      },
    );

    this.addRecaptchaScript();

    this.formValidar = this.formBuilder.group({
      id_tp_documento: new FormControl(null, Validators.required),
      ano_documento: new FormControl(null, Validators.required),
      cod_autenticidade: new FormControl(null, Validators.required),
      num_documento: new FormControl(null, Validators.required),
    });
  }

  goTop() {
    window.scrollTo(0, 0);
  }

  onSubmit(formData) {
    this.err_msg = null;
    formData['ano_documento'] = formData['ano_documento'].replace('.', '');

    formData['g_recaptcha_response'] = this.captchaStr || '';
    this.resetCaptcha();

    this.goTop();
    this.spinner.show();

    this.api.postValidaDocumento(formData).subscribe(
      res => {
        this.spinner.hide();
        if (res['message'] == false) {
          this.err_msg = {
            alert_class: 'alert-danger',
            text: 'Esta emissão não foi encontrada no sistema e, portanto, não foi validada.',
          };
        } else {
          let message = '';
          let alert_class = 'alert-success';
          const document_type = this.document_type_list.find(el => {
            return el.id_tp_documento === formData['id_tp_documento'];
          });

          if (res['message'] == true) {
            // Tipo diferente de Recibo Eletrônico
            message = `${document_type['tp_documento']} ${formData['num_documento']}/${formData['ano_documento']} emitida e validada pelo Sistema de Informações do LCCV (Sumé).`;
          } else if (res['message'] == undefined) {
            // Tipo Recibo Eletrônico
            message = `${document_type['tp_documento']} ${
              formData['num_documento']
            }/${formData['ano_documento']} referente ao projeto ${
              res['titulo_curto']
            } assinado ${
              res['nome_colaborador'] ? 'por ' + res['nome_colaborador'] : ''
            } em ${new Intl.DateTimeFormat('pt-br').format(
              formatDate(res['data_assinatura']),
            )} emitido e validado pelo Sistema de Informações do LCCV (Sumé).`;
          } else {
            message = res['message'];
            alert_class = 'alert-danger';
          }

          this.err_msg = {
            alert_class: alert_class,
            text: message,
          };
        }
      },
      err => {
        this.spinner.hide();
        this.err_msg = {
          alert_class: 'alert-warning',
          text: 'Objeto JSON do erro: ' + JSON.stringify(err),
        };
        console.error(err);
      },
    );
  }

  resetCaptcha() {
    window['grecaptcha'].reset();
    this.captchaStr = null;
  }

  onClear() {
    this.formValidar.reset();
    this.submit_hover = false;
    this.resetCaptcha();
  }

  addRecaptchaScript() {
    window['grecaptchaCallback'] = () => {
      this.renderReCaptcha();
    };

    (function (d, s, id, obj) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        obj.renderReCaptcha();
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src =
        'https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'recaptcha-jssdk', this);
  }

  renderReCaptcha() {
    window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      sitekey: '6Lfxe_sUAAAAAL0ge8XqcxW93D9kdZ6nVfHi-zPL',
      callback: response => {
        this.captchaStr = response;
      },
    });
  }

  get id_tp_documento() {
    return this.formValidar.get('id_tp_documento');
  }
  get ano_documento() {
    return this.formValidar.get('ano_documento');
  }
  get cod_autenticidade() {
    return this.formValidar.get('cod_autenticidade');
  }
  get num_documento() {
    return this.formValidar.get('num_documento');
  }
}
